import * as types from "./dadup.types";

const initialState = {
	form_values: null,
};

// biome-ignore lint/style/useDefaultParameterLast: It's required by Redux to ask for the state first.
export default function dadup_reducer(state = initialState, action) {
	switch (action.type) {
		// SET FORM VALUES
		case types.DADUP_FORM_VALUES_SET:
			return {
				...state,
				form_values: action.payload,
			};

		// RESET FORM VALUES
		case types.DADUP_FORM_VALUES_RESET:
			return initialState;

		default:
			return state;
	}
}
